export default "__VITE_ASSET__Bzpt3LpL__"